import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

export enum PanelReferralPayoutsEditResolverErrorStatesEnum {
    GetPayoutRequestFailed = ErrorStateScheduleEnum.PanelReferralPayoutsEditResolverStatesStartIndex,
    PayoutRequestNotFound,
    InvalidPayoutRequestData
}
